<template>
  <div class="input__wrp">
    <div class="bim-input" :class="{
      focus,
      notEmpty: value,
      disabled,
      valid,
      invalid: (valid === false || observableError)
    }">
      <MaskedInput
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
        :value="value"
        v-on="$listeners"
        :name="name"
        :id="id"
        v-bind="$attrs"
        :type="type"
        :disabled="disabled"
        :mask="inputMask"
        :guide="false"
        :ref="uniqRef"
        @keyup.enter="onEnterInput"
        :style="`
          background: ${background};
          width: ${computedWidth};
        `"
      />
      <label :style="`background: ${background}`">{{placeholder}}</label>
      <slot />
    </div>

    <!--подсказки от dadata -->
    <div v-if="dadataItems.length && focus" class="suggestions__wrp">
      <div
        v-for="(item,index) in dadataItems"
        :key="index"
        class="suggestion"
        @click="dadataItemClicked(item)"
      >
        <span>
          {{ item.value }}
        </span>
        <div v-if="item.hint" class="suggestion__hint">
          {{ item.hint }}
        </div>
      </div>
    </div>

    <!--кастомные подсказки-->
    <div v-if="suggestionItems.length && focus && !edited" class="suggestions__wrp">
      <div
        v-for="(item,index) in suggestionItems"
        :key="index"
        class="suggestion"
        @click="updateValue(item)"
      >
        <!-- @slot Слот кастомной подсказки для изменения вывода-->
        <slot name="suggestion_item" v-bind:item="item">
          {{ item }}
        </slot>
      </div>
    </div>

    <div class="desc__block" v-if="!observableError && desc">{{desc}}</div>
    <transition name="error-slide">
      <bimErrorField v-if="observableError" :error="observableError" />
    </transition>
  </div>
</template>

<script>
import MaskedInput from '@/components/core/masked-input'
import ValidationFormMixin from '@/utils/validate2/validation-form-mixin'
import bimErrorField from '@/components/form/bimErrorField/bimErrorField'
import DadataMixin from '@/components/core/dadata-mixin'

const ruGlobalPhoneMask = ['+', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/]
const ruLocalPhoneMask = [/\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/]
const defaultPhoneMask = ['+', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

export default {
  name: 'bimInput',
  mixins: [ValidationFormMixin, DadataMixin],
  components: {
    MaskedInput,
    bimErrorField
  },
  model: {
    event: 'inputValue'
  },
  props: {
    /**
     * Поясняющая подсказка снизу
     */
    desc: String,
    /**
     * Значение инпута
     * @model
     */
    value: {
      type: [String, Number]
    },
    /**
     * Имя поля
     */
    name: {
      type: String
    },
    /**
     * ID поля
     */
    id: {
      type: String
    },
    /**
     * Значение placeholder
     */
    placeholder: {
      type: [String, Number],
      default: 'Введите текст'
    },
    /**
     * Тип инпута
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Отключает инпут
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * При необходимости передаёт валидно ли поле
     */
    valid: {
      type: Boolean,
      default: null
    },
    /**
     * Маска
     * @values inn, phone, date или своя версия (00-00-00-000)
     */
    mask: {
      type: String,
      default: ''
    },
    /**
     * Автоматически ставит фокус на инпут. Работает только на одном инпуте. Если таких инпутов несколько, фокус будет на последнем из них
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Заменяет фон инпута (transparent не прадлагать)
     */
    background: {
      type: String,
      default: '#ffffff'
    },
    /**
     * Ширина
     */
    width: [String, Number],
    /**
     * список кастомных подсказок
     */
    suggestionItems: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      focus: false,
      edited: false,
      phoneMask: false
    }
  },
  watch: {
    value (value) {
      this.edited = true
      this.$nextTick(this.calculateInputMask)
    }
  },
  mounted () {
    if (this.autofocus) this.onAutofocus()
    this.calculateInputMask()
  },
  computed: {
    computedWidth () {
      if (+this.width) {
        return this.width + 'px'
      } else {
        return this.width
      }
    },
    uniqRef () {
      return 'input' + Date.now()
      // return `input${Date.now()}`
    },
    inputMask () {

      if (this.mask) {
        switch (this.mask) {
          case 'inn':
            return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
          case 'date':
            return [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]
          case 'phone':
            return this.phoneMask
        }

        let inputMask = this.mask.split('')

        inputMask = inputMask.map(char => (char === '0' ? /\d/ : char))

        return inputMask
      }

      return false
    }
  },
  methods: {
    onInput (value) {
      /* корректное удаление маски телефона */
      if (
        this.mask === 'phone' &&
        value && value.length < this.value.length &&
        this.value.slice(-1).match(/\D/)
      ) {
        const numbers = value.match(/\d/g) || []
        value = numbers.slice(0, -1).join('')
      }

      this.$emit('inputValue', value)
      this.$emit('input', value)
    },
    onEnterInput () {
      /**
       * событие нажатия на enter
       */
      this.$emit('enter')
    },
    calculateInputMask () {
      if (this.mask !== 'phone') return

      let emitValue,
        newPhoneMask,
        phoneNumber = this.value || ''

      try {
        phoneNumber = phoneNumber.match(/\d/g).join('')
      } catch (e) {}

      if (phoneNumber.length <= 11) {
        if (
          phoneNumber.slice(0, 3) === '800' ||
          phoneNumber.slice(0, 4) === '8800' ||
          phoneNumber.slice(0, 4) === '7800'
        ) {
          /* номера с кодом 800 */

          if (phoneNumber.slice(0, 3) === '800') {
            emitValue = '8' + phoneNumber
          }
          if (phoneNumber.slice(0, 4) === '7800') {
            emitValue = '8' + phoneNumber.slice(1)
          }

          newPhoneMask = ruLocalPhoneMask

        } else if (phoneNumber.slice(0, 1) === '7') {
          /* начинается на 7 */
          newPhoneMask = ruGlobalPhoneMask

        } else if (
          /* российские номера начинающиеся с 8 */
          phoneNumber.slice(0, 1) === '8' &&
          phoneNumber.length === 11
        ) {
          emitValue = '7' + phoneNumber.slice(1)
          newPhoneMask = ruGlobalPhoneMask
        } else if (
          /* российские номера с кодом 9.x.x */
          phoneNumber.slice(0, 1) === '9' &&
          phoneNumber.length === 10
        ) {
          emitValue = '7' + phoneNumber
          newPhoneMask = ruGlobalPhoneMask
        }
      } else {
        if (phoneNumber.slice(0, 1) === '7') {
          emitValue = phoneNumber.slice(1)
        }
      }

      if (emitValue && emitValue !== this.value) this.$emit('inputValue', emitValue)

      if (newPhoneMask) {
        this.phoneMask = [].concat(newPhoneMask)
      } else {
        this.phoneMask = defaultPhoneMask
      }
    },
    onFocus () {
      this.focus = true
      /**
       * Событие срабатывает при фокусе на поле
       */
      this.$emit('focus')
    },
    onBlur () {
      setTimeout(() => {
        this.edited = false
        this.focus = false
      }, 400)

      /**
       * Событие срабатывает при потере фокуса с поля
       */
      this.$emit('blur')
    },
    onAutofocus () {
      this.$refs[this.uniqRef].$el.focus()
    },
    updateValue (value) {
      this.$emit('input', value)
      this.$emit('inputValue', value)
      this.edited = true
    },
  },
}
</script>

<style lang="scss" scoped>

$active: $primary-color;
$error: $red-color-400;

%font {
  @include text-style(14px, normal, 1.57, 0.2px);
}

.input__wrp {
  position: relative;
}

.desc__block {
  margin-left: 12px;
  margin-top: 6px;
  color: #6c6c6c;
  font-size: 13px;
}

.bim-input {
  position: relative;
  transition: all .2s;
  height: 36px;
  &:hover {
    input {
      border-color: rgba($black-color, .5);
    }
    label {
      color: rgba($black-color, .6);
    }
  }
  %active-placeholder {
    padding: 0 5px;
    height: 10px;
    @include text-style(8px);
    top: 0;
  }

  &.focus {
    input {
      border-color: rgba($black-color, .75);
    }
    label {
      @extend %active-placeholder;
    }
  }

  &.notEmpty {
    label {
      @extend %active-placeholder;
    }
  }

  &.valid {
    input {
      border-color: $active;
    }
    label {
      color: $active;
    }
  }

  &.invalid {
    input {
      border-color: $error;
    }
    label {
      color: $error;
    }
  }
  input {
    box-sizing: border-box;
    width: 100%;
    outline: none;
    transition: inherit;
    border-radius: 5px;
    border: solid 1px rgba($black-color, .25);
    height: 36px;
    padding: 7px 12px;
    @extend %font;
  }
  label {
    transition: inherit;
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    @extend %font;
    color: rgba($black-color, .4);
    pointer-events: none;
  }

  &.disabled {
    input {
      border: solid 1px $white-color-100;
      background-color: $white-color-100;
    }
    label {
      color: rgba($black-color, 0.5);
      &:after {
        background-color: transparent;
      }
    }
  }
}

.suggestions__wrp {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  z-index: 10;
  background: white;
  border: 1px solid #afafaf;
  padding: 5px 0;
  border-radius: 4px;
  color: #222;
  max-height: 210px;
  overflow-y: auto;
}

.suggestion {
  padding: 6px 0 6px 12px;
  line-height: 1.4;
  font-size: 14px;
}

.suggestion__hint {
  color: #989898;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.suggestion:hover,
.suggestion.active__item {
  background-color: #ececec;
  cursor: pointer;
}

.error-slide-enter-active {
  position: relative;
  animation: error-slide .5s;
}
.error-slide-leave-active {
  position: relative;
  animation: error-slide .5s reverse;
}

@keyframes error-slide {
  0% {
    left: 100px;
    opacity: 0;
  }
  50% {
    left: -10px;
    opacity: 1;
  }
  100% {
    left: 0;
  }
}
</style>
